import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "arrow.left.down-16", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", strokeLinecap: "round", stroke: "currentColor", strokeWidth: 1.5 },
        React.createElement("path", { d: "M8 11V5.5A2.5 2.5 0 0110.5 3h0" }),
        React.createElement("path", { strokeLinejoin: "round", d: "M5.5 10L8 12.5l2.5-2.5" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
